<template>
  <div>
    <v-container class="pa-0" v-if="transport != null">
      <v-row v-if="getSelectedResource !== null">
        <v-col class="pa-2" cols="12">
          <OrdersContextLocation :selectedOrder="transport"/>
          <v-btn x-small class="ma-2" tile outlined color="kazan" @click="editPickupDelivery = true">
            <v-icon x-small left>fas fa-pen</v-icon> {{ $t('transport_request.edit_pickup_delivery') }}
          </v-btn>
        </v-col>
        <v-col class="pt-3 pl-2 pr-2" cols="12">
          <ContextItemAutoComplete
            :iconTooltip="$t('orders.incoterms')"
            :icon="'fas fa-align-justify'"
            :value="transport.incoterms"
            :bottom="false"
            @autocompleteSave="selectIncoterm"
            :list="incoterms"
            />
          <ContextItemAutoComplete
            :iconTooltip="$t('orders.status')"
            :icon="'far fa-clipboard'"
            :value="computedOrderStatus"
            @autocompleteSave="selectStatus"
            :list="orderStatuses"
          />
          <ContextItemAutoComplete
            :iconTooltip="$t('orders.priority')"
            :icon="'fas fa-angle-double-up'"
            :value="computedOrderPriority"
            @autocompleteSave="selectPriority"
            :list="orderPriorities"
          />
          <ContextItem
            :iconTooltip="$t('orders.total_weight_2')"
            :icon="'fas fa-box'"
            :attribute="$t('drops.total_weight_is')"
            :value="`${computedWeight} kg`"
          />
          <ContextItem
            :iconTooltip="$t('orders.total_volume_2')"
            :icon="'fas fa-arrows-alt'"
            :attribute="$t('drops.total_volume_is')"
            :value="`${transport.volume.toFixed(1) }  m³`"
          />
          <!-- TODO: if it is in more than 1 shipment there should be linku to all of them not only to first -->
          <ContextItem
            :iconTooltip="$t('orders.shipments')"
            :icon="'fas fa-truck'"
            :customBody="transportShipments.length > 0"
            :attribute="$t('orders.not_assigned_shipment')"
          >
            <template v-slot:customBody>
              <v-btn text small :href="'#/shipments-new/' + transportShipments[0] + '/schedule'" target="_blank">{{ $t('transport_request.link_to_shipment') }}</v-btn>
            </template>
          </ContextItem>

          <ContextItem
            :iconTooltip="$t('orders.units')"
            :attribute="unitsCount + ' ' + $t('orders.units')"
            :icon="'fas fa-boxes'"
            :actionIcons="{edit: 'custom', expand: true}"
            @customEditEmitted="editUnits = !editUnits"
          >
            <template v-slot:expandablePart>
              <div class="context--expandlist__container">
                <div class="context--expandlist__list">
                  <v-simple-table
                    :dense="true"
                    :fixed-header="true"
                    :height="125"
                    class="units-table"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">{{ $t('general.reference') }}</th>
                          <th class="text-left">{{ $t('general.type') }}</th>
                          <th class="text-left">{{ $t('orders.dims') }}</th>
                          <th class="text-left">{{ $t('orders.weight') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="unit in transport.units" :key="unit.id">
                          <td>{{ unit.ref }}</td>
                          <td>{{ $t('packages_type.' + unit.type) }}</td>
                          <td>{{ unit.dimensions | dimensionValue }}</td>
                          <td>{{ (unit.weight/1000).toFixed(0) }}kg</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </div>
            </template>
          </ContextItem>
          <!-- <ContextItemLabels
            :isEditable="true"
            :iconTooltip="$t('shipments.labels')"
            :labels="computeTransportLabels"
            :eventName="'click'"
            @handleSaveLabels="handleSaveLabels"
            :algoliaSearchLabels="null"
          /> -->
          <ContextItem
            :iconTooltip="$t('orders.restrictions')"
            :attribute="allRestrictions.length + ' ' + $t('orders.restrictions')"
            :icon="'fas fa-times-circle'"
            :actionIcons="{edit: 'custom', expand: true}"
            @customEditEmitted="editRestrictions = !editRestrictions"
          >
            <template v-slot:expandablePart>
              <div class="context--expandlist__container">
                <div class="context--expandlist__list">
                  <ul class="pl-0">
                    <li class="context--expandlist__card" :key="restriction.value" v-for="restriction in allRestrictions">
                      <span class="context--expandlist__title context--text--alignLeft flex--width--25">
                        {{restriction.text}}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </ContextItem>
          <ContextTitle :title="$t('orders.transport_comment')" class="mb-1" :enableInfoIcon="false"/>
          <ContextItemEditableTextArea
            :value="transport.comment"
            :eventName="'click'"
            @save-emitted="handleComment"
            :savedByEnter="true"
            :emptyValue="$t('general.add_description')"
          />
        </v-col>
        <!-- <v-col
          cols="12"
          class="text-right"
        >
          <OrdersQuoting
            :transport="transport"
          />
        </v-col> -->
      </v-row>
    </v-container>
    <EditPickupDelivery
      :openMenu="editPickupDelivery"
      :editableTransport="transport"
      @close="editPickupDelivery = false"
    />
    <EditRestrictions
      :openMenu="editRestrictions"
      :editableTransport="transport"
      @close="editRestrictions = false"
    />
    <EditUnits
      :openMenu="editUnits"
      :editableTransport="transport"
      @close="editUnits = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContextTitle from '@/components/drops/detail/ContextTitle'
import ContextLabel from '@/components/drops/detail/ContextLabel'
import OrdersContextLocation from '@/components/orders/new/OrdersContextLocation'
import EditPickupDelivery from '@/components/orders/new/EditPickupDelivery'
import EditRestrictions from '@/components/orders/new/EditRestrictions'
import EditUnits from '@/components/orders/new/EditUnits'
import ContextItem from '@/components/wrld/generic/ContextItem'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete'
import ContextItemEditableTextArea from '@/components/wrld/generic/ContextItemEditableTextArea'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels'
import OrdersQuoting from '@/components/orders/new/OrdersQuoting'
import { transportRequestService } from '@/_services'

export default {
  name: 'OrderOverviewContext',
  components: {
    OrdersContextLocation,
    ContextItem,
    ContextLabel,
    ContextItemAutoComplete,
    ContextItemEditableTextArea,
    ContextTitle,
    EditPickupDelivery,
    ContextItemLabels,
    EditRestrictions,
    EditUnits,
    OrdersQuoting
  },
  data () {
    return {
      editPickupDelivery: false,
      editRestrictions: false,
      editUnits: false
    }
  },
  // mounted () {
  //   this.transport = JSON.parse(JSON.stringify({ ...this.getSelectedResource }))
  // },
  methods: {
    ...mapActions({
      setTransportPriority: 'setTransportPriority',
      setTransportIncoterms: 'setTransportIncoterms',
      setTransportStatus: 'setTransportStatus',
      setTransportComment: 'setTransportComment',
    }),
    selectIncoterm (value) {
      this.setTransportIncoterms({ transportID: this.transport.id, value: value, oldVal: this.transport.incoterms })
    },
    selectStatus (value) {
      this.setTransportStatus({ transportID: this.transport.id, value: value, oldVal: this.transport.status })
    },
    selectPriority (value) {
      this.setTransportPriority({ transportID: this.transport.id, value: value, oldVal: this.transport.priority })
    },
    handleComment (value) {
      this.setTransportComment({ transportID: this.transport.id, value: value, oldVal: this.transport.comment })
    },
    handleSaveLabels (labels) {
      const newLabels = labels.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.transport.labels === null) {
        this.transport.labels = []
      }
      this.transport.labels.forEach((label) => {
        if (newLabels.indexOf(label) < 0) {
          remove.push(label)
        }
      })
      newLabels.forEach((label) => {
        if (this.transport.labels.indexOf(label) < 0) {
          add.push(label)
        }
      })
      const transport = { ...this.transport, labels: newLabels}
      // this.setOrganizationLabels({ organization, organizationID: this.organization.id, remove, add, newLabels: newLabels })
    },
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getTransportResourceDetails'
    ]),
    transport() {
      return {
        ...this.getTransportResourceDetails
      }
    },
    transportShipments() {
      let shipments = []
      if (!!this.transport.drops) {
        this.transport.drops.forEach(drop => {
          if (drop.shipment !== null) {
            shipments.push(drop.shipment)
          }
        });
      }
      return shipments
    },
    computedWeight () {
      let weight = 0
      if (this.transport !== null) {
        weight = this.transport.weight / 1000
      }
      return weight.toFixed(0)
    },
    computedOrderStatus () {
      if (this.transport.status != null && this.transport.status != '') {
        return this.$t('transport_request.' + this.transport.status)
      }
      return null
    },
    computedOrderPriority () {
      if (this.transport.priority != null && this.transport.priority != '') {
        return this.$t('priorities.' + this.transport.priority)
      }
      return null
    },
    incoterms() {
      return [
        {id:'EXW', text: 'EXW'},
        {id:'FCA', text: 'FCA'},
        {id:'FOB', text: 'FOB'},
        {id:'CPT', text: 'CPT'},
        {id:'CIP', text: 'CIP'},
        {id:'DPU', text: 'DPU'},
        {id:'DAP', text: 'DAP'},
        {id:'DDP', text: 'DDP'},
        {id:'FAS', text: 'FAS'},
        {id:'CFR', text: 'CFR'},
        {id:'CIF', text: 'CIF'},
      ]
    },
    orderStatuses () {
      return [
        { id: 'Requested', value: 'Requested', text: this.$i18n.t('transport_request.Requested') },
        { id: 'Booked', value: 'Booked', text: this.$i18n.t('transport_request.Booked') },
        { id: 'Canceled', value: 'Canceled', text: this.$i18n.t('transport_request.Canceled') },
        { id: 'MissingData', value: 'MissingData', text: this.$i18n.t('transport_request.MissingData') }
      ]
    },
    orderPriorities () {
      return [
        { id:'Lowest', value: 'Lowest', text: this.$i18n.t('priorities.Lowest') },
        { id:'Low', value: 'Low', text: this.$i18n.t('priorities.Low') },
        { id:'Medium', value: 'Medium', text: this.$i18n.t('priorities.Medium') },
        { id:'High', value: 'High', text: this.$i18n.t('priorities.High') },
        { id:'Highest', value: 'Highest', text: this.$i18n.t('priorities.Highest') },
      ]
    },
    unitsCount () {
      let count = 0
      if (!!this.transport.units) {
        count = this.transport.units.length
      }
      return count
    },
    computeTransportLabels () {
      let transportLabels = []
      if (this.transport.labels !== null) {
        this.transport.labels.forEach((label) => {
          transportLabels.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return transportLabels
    },
    allRestrictions () {
      let all = []
      if (!!this.transport.restrictions) {
        for (let i = 0; i < this.transport.restrictions.vehicle.length; i++) {
          const element = this.transport.restrictions.vehicle[i];
          all.push({value: element, text: this.$i18n.t('orders.vehicle_restirction.' + element)})
        }
        for (let i = 0; i < this.transport.restrictions.cargo.length; i++) {
          const element = this.transport.restrictions.cargo[i];
          all.push({value: element, text: this.$i18n.t('orders.cargo_restirction.' + element)})
        }
        for (let i = 0; i < this.transport.restrictions.location.length; i++) {
          const element = this.transport.restrictions.location[i];
          all.push({value: element, text: this.$i18n.t('orders.location_restirction.' + element)})
        }
      }
      return all
    }
  },
}
</script>

<style lang="scss" scoped>
  .units-table {
    border: 1px darkgray solid;
  }
</style>
